export const yearGroupOptions = [
  { naam: "0", key: 0 },
  { naam: "1", key: 1 },
  { naam: "2", key: 2 },
  { naam: "3", key: 3 },
  { naam: "4", key: 4 },
  { naam: "5", key: 5 },
  { naam: "6", key: 6 },
  { naam: "7", key: 7 },
  { naam: "8", key: 8 },
  { naam: "11", key: 11 },
  { naam: "12", key: 12 },
  { naam: "13", key: 13 },
  { naam: "14", key: 14 },
  { naam: "15", key: 15 },
  { naam: "16", key: "16" },
  { naam: "S", key: "S" },
  { naam: "C", key: "C" },
  { naam: "N", key: "N" },
  { naam: "H", key: "H" },
];

export const yearGroupOptionsPupils = [
  { naam: "0", key: 0 },
  { naam: "1", key: 1 },
  { naam: "2", key: 2 },
  { naam: "3", key: 3 },
  { naam: "4", key: 4 },
  { naam: "5", key: 5 },
  { naam: "6", key: 6 },
  { naam: "7", key: 7 },
  { naam: "8", key: 8 },
  { naam: "11", key: 11 },
  { naam: "12", key: 12 },
  { naam: "13", key: 13 },
  { naam: "14", key: 14 },
  { naam: "15", key: 15 },
  { naam: "16", key: "16" },
  { naam: "S", key: "S" },
  { naam: "V", key: "V" },
];
